import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

interface GroupBarChartProps {
  dataObject?: object;
  campoTitulo?: string;
  camposDatos: string;
  tituloValor?: string;
}

const PieChart: React.FC<GroupBarChartProps> = ({ dataObject, campoTitulo, camposDatos, tituloValor }) => {
  const entries = Array.isArray(dataObject) ? (dataObject as any[]) : [];

  const labels = entries.map(item => item[campoTitulo ?? '']);
  const datos = entries.map(item => item[camposDatos]);

  const cleanLabel = tituloValor?.replace(/:$/, '') ?? 'Datos';

  const total = datos.length > 0
    ? datos.reduce((acc: number, val: number) => acc + (typeof val === 'number' ? val : 0), 0)
    : 'SIN REGISTROS';

  const defaultColors = [
    '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40',
    '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40',
  ];

  const data: ChartData<'pie', number[], string> = {
    labels: labels.length ? labels : [],
    datasets: [
      {
        label: cleanLabel,
        data: datos.length ? datos : ['SIN REGISTROS'],
        backgroundColor: defaultColors,
        borderWidth: 1,
      },
    ],
  };

  const options: ChartOptions<'pie'> = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          generateLabels: (chart) => {
            const data = chart.data;
            return data.labels?.map((label: any, i: number) => {
              const dataset = data.datasets[0];
              const bgColor = Array.isArray(dataset.backgroundColor)
                ? dataset.backgroundColor[i]
                : dataset.backgroundColor;

              return {
                text: label,
                fillStyle: bgColor,
                hidden: isNaN(dataset.data[i] as number) || chart.getDataVisibility(i) === false,
                index: i,
              };
            }) ?? [];
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.parsed || '';
            return `${label} ${value}`.trim();
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }}>
      <Pie data={data} options={options} />
      <div style={{ marginTop: 8, fontWeight: 'bold' }}>
        Total: {total}
      </div>
    </div>

  );
};

export default PieChart;
